/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 11:33:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-11 10:04:08
 * @name: 装饰器@controller
 * @Description: 控制器
 * @FilePath: \practice\src\nestVue\common\decorators\controller.js
 * @Author: desktop
 */
/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 控制器
 * @param {String} name 控制器模块名
 */
export function Controller(name) {
  return function (target) {
    target.prototype.ctx = {
      module: name, //模块名
      request: {}, //请求体
      validator: {
        code: 1,
        msg: '',
      }, //验证
      response: {}, //回传结果
    }; //执行上下文
  }
}